import { get } from "lodash-es";
import { MESApiService } from "../../../services/ApiService";
import { ShiftNavigatorFilterParams } from "../../shift-navigator-v2";

export const getShiftByParameters = async (
	parameters: ShiftNavigatorFilterParams,
) => {
	const utcString = parameters.productionDate?.toISOString();

	try {
		const sqlParameters = [];
		sqlParameters.push({
			name: "@ShiftId",
			value: parameters.shiftId === 0 ? null : parameters.shiftId,
		});
		sqlParameters.push({
			name: "@ProductionDate",
			value: utcString,
		});
		sqlParameters.push({
			name: "@AssetId",
			value: parameters.assetId ?? null,
		});
		const apiService = new MESApiService();
		const resp = await apiService.callV2(
			"[MES].[GetShiftByParameters]",
			sqlParameters,
		);

		if (resp.ok) {
			return {
				ok: true,
				data: get(resp.data, "tables[0].rows[0]", {}),
			};
		} else {
			return {
				ok: false,
				message: resp.message,
			};
		}
	} catch (e: any) {
		return { ok: false, message: e.toString() };
	}
};
